import { IFeedback, IXMLHttpConfig } from "../global/types";
import { XMLHttpConfig } from "../global/XMLHttpConfig";
import { HttpService } from "../services/HttpService";

declare var _gaq: any;

export class Feedback {
    private httpSvc: HttpService;
    private locationNodeId: string;
    private commentsLoaded: number;
    private returnDate: string;
    private dateApproved: string;
    private feedbackTotal: number;

    constructor() {
        this.httpSvc = new HttpService();
        this.fetchPageData();

        this.updateCommentCount();

        if (this.commentsLoaded === this.feedbackTotal) {
            this.hideButton();
        } else {
            this.bindInteractions();   
        }
    }

    private fetchPageData() {
        const spanWebLoc: HTMLElement = document.querySelector("[data-feedback-webloc]") as HTMLElement;
        const spanReturn: HTMLElement = document.querySelector("[data-feedback-return]") as HTMLElement;
        const spanApproved: HTMLElement = document.querySelector("[data-feedback-approved]") as HTMLElement;
        const commentCount: NodeListOf<HTMLElement> = document.querySelectorAll("[data-feedback-item]") as NodeListOf<HTMLElement>;
        const spanTotal: HTMLElement = document.querySelector("[data-feedback-total]") as HTMLElement;

        this.locationNodeId = spanWebLoc.getAttribute("data-feedback-webloc");
        this.returnDate = spanReturn.getAttribute("data-feedback-return");
        this.dateApproved = spanApproved.getAttribute("data-feedback-approved");
        this.commentsLoaded = commentCount.length;
        this.feedbackTotal = parseInt(spanTotal.getAttribute("data-feedback-total"), 10);
    }

    private bindInteractions() {
        const feedbackContent: HTMLElement = document.querySelector(".responsive-customer-feedback-container") as HTMLElement;
        const loadMoreFeedback: HTMLElement = document.querySelector("[load-more-comments]") as HTMLElement;

        feedbackContent.addEventListener("click", (e) => {
            e.stopPropagation();
        });

        loadMoreFeedback.addEventListener("click", (e) => {
            _gaq.push(["_trackEvent", "Interaction", "View feedback MORE FEEDBACK BTN", document.URL, 0, false]);
            this.loadMoreComments();
        });
    }

    private async loadMoreComments() {
        this.setButton(false);
        this.updateCommentCount();

        const url: string = `/utility/feedbackcommentsJSON.aspx?weblocationid=${this.locationNodeId}&commentsLoaded=${this.commentsLoaded}&returndate=${this.returnDate}&dateapproved=${this.dateApproved}`;
        const rawResponse: any = await this.httpSvc.get(new XMLHttpConfig(url));

        if (rawResponse.hasOwnProperty("length") && rawResponse.length > 0) {
            this.setButton(true);
            this.appendComments(rawResponse);
        }

        this.updateCommentCount();

        if (this.commentsLoaded === this.feedbackTotal) {
            this.hideButton();
        }
    }

    private appendComments(response: any) {
        const stage: HTMLElement = document.querySelector("[data-feedback-stage]") as HTMLElement;

        for (let i = 0; i < response.length; i++) {
            const html: HTMLElement = this.createHTMLFromData(response[i]);
            stage.appendChild(html);

            if (i === response.length - 1) {
                this.returnDate = response[i].ReturnDate;
                this.dateApproved = response[i].DateTimeApproved;
            }
        }
    } 

    private setButton(enabled: boolean) {
        const button: HTMLInputElement = document.querySelector("[load-more-comments]") as HTMLInputElement;

        if (enabled) {
            button.removeAttribute("disabled");
        } else {
            button.setAttribute("disabled", "disabled");
        }
    }

    private hideButton() {
        const button: HTMLInputElement = document.querySelector("[load-more-comments]") as HTMLInputElement;
        button.style.display = "none";
    }

    private updateCommentCount() {
        const commentCount: NodeListOf<HTMLElement> = document.querySelectorAll("[data-feedback-item]") as NodeListOf<HTMLElement>;
        this.commentsLoaded = commentCount.length;      
    }

    private createHTMLFromData(commentData: IFeedback): HTMLElement {
        const feedback: HTMLElement = document.createElement("div");
        feedback.setAttribute("class", "feedback-item");
        feedback.setAttribute("itemprop", "review");
        feedback.setAttribute("itemscope", "itemscope");
        feedback.setAttribute("itemtype", "http://schema.org/Review");
        feedback.setAttribute("data-feedback-item", "");

        const span: HTMLElement = document.createElement("span");
        const meta: HTMLElement = document.createElement("meta");
        meta.setAttribute("itemprop", "datePublished");
        meta.setAttribute("content", commentData.ReturnDate);
        span.appendChild(meta);
        feedback.appendChild(span);

        const paragraph: HTMLElement = document.createElement("p") as HTMLElement;
        paragraph.setAttribute("class", "feedback-item__body");
        paragraph.setAttribute("itemprop", "reviewBody");
        paragraph.innerText = commentData.Comments;
        feedback.appendChild(paragraph);

        const details: HTMLElement = document.createElement("p") as HTMLElement;
        details.setAttribute("class", "feedback-item__footer");

        const author: HTMLElement = document.createElement("span") as HTMLElement; 
        author.setAttribute("itemprop", "author");
        author.innerText = commentData.ClientName;

        const spanSeparator: HTMLElement = document.createElement("span") as HTMLElement; 
        spanSeparator.innerHTML = " <strong>|</strong> ";

        const postDate: HTMLElement = document.createElement("span") as HTMLElement; 
        postDate.setAttribute("class", "postdate");
        postDate.innerText = `Posted on ${commentData.ReturnDateFormatted}`;

        const br: HTMLElement = document.createElement("br") as HTMLElement; 

        const visited: HTMLElement = document.createElement("span") as HTMLElement;
        visited.innerHTML = `Visited <strong>${commentData.Destination}</strong>`;

        const br2: HTMLElement = document.createElement("br") as HTMLElement; 

        const rating: HTMLElement = document.createElement("span") as HTMLElement; 
        rating.setAttribute("itemprop", "reviewRating");
        rating.setAttribute("itemscope", "");
        rating.setAttribute("itemtype", "http://schema.org/Rating");

        const meta1: HTMLElement = document.createElement("meta");
        meta1.setAttribute("itemprop", "worstRating");
        meta1.setAttribute("content", "1");

        const meta2: HTMLElement = document.createElement("meta");
        meta2.setAttribute("itemprop", "ratingValue");
        meta2.setAttribute("content", commentData.Rating.toString());

        const meta3: HTMLElement = document.createElement("meta");
        meta3.setAttribute("itemprop", "bestRating");
        meta3.setAttribute("content", "5");

        const itemReviewed: HTMLElement = document.createElement("meta");
        meta3.setAttribute("itemprop", "itemReviewed");
        meta3.setAttribute("content", `Visited ${commentData.Destination}`);

        rating.appendChild(meta1);
        rating.appendChild(meta2);
        rating.appendChild(meta3);

        details.appendChild(author);
        details.appendChild(spanSeparator);
        details.appendChild(postDate);
        details.appendChild(br);
        details.appendChild(visited);
        details.appendChild(br2);

        details.appendChild(rating);
        details.appendChild(itemReviewed);

        feedback.appendChild(span);
        feedback.appendChild(paragraph);
        feedback.appendChild(details);

        return feedback;   
    }
}



// WEBPACK FOOTER //
// ./src/global/Feedback.ts